






















































































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";

// Enums / Data
import { BrandConfigKeys } from "@/data/constants";
import { STATS_ALL_CURRENCY_CODE } from "@/data/constants";
import { TicketStatusCodes as TSC } from "@/data/enums/tickets";
import { IsActiveParam } from "@/data/filters/contractProducts";

// Types
import { IClient } from "@/models/clients";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";

@Component({
  components: {
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "recent-tickets-list": () =>
      import("@/components/app/global/tickets/recentTicketsList.vue"),
    "invoices-total": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "invoices-total-unpaid": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "total-orders": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "tickets-open": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "cprods-provider": () =>
      import("@/components/app/global/contractProducts/cProdsProvider.vue"),
    "cprod-well-link": () =>
      import("@/components/app/global/contractProducts/cProdWellLink.vue"),
    "cprods-onboarding": () =>
      import("@/components/app/global/contractProducts/cProdsOnboarding.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientInvoices extends Mixins(StatsCurrencyMixin) {
  public currencyCode = STATS_ALL_CURRENCY_CODE;
  public readonly ticketsListProps = {
    limit: 4,
    statuses: [
      TSC.OPEN,
      TSC.IN_PROGESS,
      TSC.AWAITING_RESPONSE,
      TSC.CLIENT_REPLIED
    ]
  };

  public get clientId(): IClient["id"] {
    return this.$store.state.user.id;
  }

  public get productsTitle() {
    return this.$t(
      this.$store.getters["ui/isMobile"]
        ? "_.active_products"
        : "_.active_products_and_services"
    );
  }

  public get cProdFilters() {
    return IsActiveParam();
  }

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.DASHBOARD_OVERVIEW,
      objectId: this.clientId
    };
  }

  public get showSupportTickets() {
    return !(
      this.$store.getters["brand/config"][
        BrandConfigKeys.UI_CLIENT_APP_DISABLE_SUPPORT_SYSTEM
      ] ?? false
    );
  }
}
